import { AppliedVoucher } from '../models/reservation.model';

export class UpdateVoucher {
  static readonly type = '[Reservation] Update Voucher';
  constructor(public vouchers: AppliedVoucher[] | null) {}
}
